const quickLinks = [
  { href: '#home', label: '首页' },
  { href: '#topics', label: '热门话题' },
  { href: '#highlights', label: '心得精选' },
  { href: '#faq', label: '常见问题' },
];

const categoryLinks = ['影剧综艺', '游戏电竞', '数码科技', '职场成长', '生活杂谈', '历史人文'];

export default function Footer() {
  const jump = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };
  const jumpCategory = (name: string) => {
    const card = document.getElementById('categories');
    if (card) card.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-accent-900 text-accent-100">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4 md:py-14">
        <div>
          <a href="#home" onClick={(e) => { e.preventDefault(); jump('#home'); }} className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-accent-900">
              <i className="ri-chat-voice-line text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-background-50">看料社</span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-accent-200">
            看料心得与经验分享的互动讨论聚集地，交流真实感受、畅所欲言，来了就能找到同好一起聊。
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm text-accent-200">
            <i className="ri-mail-line"></i>
            <a href="mailto:hello@kanliao.cc" className="hover:text-background-50 transition-colors">
              hello@kanliao.cc
            </a>
          </div>
        </div>

        <nav aria-label="页脚快速导航">
          <h4 className="font-heading text-base font-bold text-background-50">
            <a href="#home" className="hover:text-background-50 transition-colors">快速导航</a>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((l) => (
              <li key={l.href + l.label}>
                <a
                  href={l.href}
                  onClick={(e) => { e.preventDefault(); jump(l.href); }}
                  className="text-sm text-accent-200 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="font-heading text-base font-bold text-background-50">内容分类</h4>
          <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2.5">
            {categoryLinks.map((c) => (
              <li key={c}>
                <a
                  href="#categories"
                  onClick={(e) => { e.preventDefault(); jumpCategory(c); }}
                  className="text-sm text-accent-200 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-bold text-background-50">关于社区</h4>
          <p className="mt-4 text-sm leading-relaxed text-accent-200">
            无论新手还是老手，每次真诚分享都有价值。友善交流、互帮互助，是我们共同守护的氛围。
          </p>
          <a
            href="#join"
            onClick={(e) => { e.preventDefault(); jump('#join'); }}
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            加入交流
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      <div className="border-t border-accent-800">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-accent-300 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 看料社 · 看料心得经验分享互动讨论社区</p>
          <div className="flex items-center gap-4">
            <a href="#home" onClick={(e) => { e.preventDefault(); jump('#home'); }} className="hover:text-background-50 transition-colors">社区公约</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); jump('#faq'); }} className="hover:text-background-50 transition-colors">帮助中心</a>
            <a href="mailto:hello@kanliao.cc" className="hover:text-background-50 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}